module.exports = __webpack_public_path__ + "static/media/visit-nepal.16f6a7f5.jpg";